// Assets
import {IoMdCheckmark, IoMdCheckmarkCircle, IoMdTrendingUp} from "react-icons/io";
import {
    MdVerified,
    MdOutlineMonetizationOn,
    MdRadioButtonChecked,
    MdEdit,
    MdTitle,
    MdOutlineTitle, MdOutlineSave, MdOutlineCancel, MdOutlineCameraAlt
} from "react-icons/md";
import TextField from "./TextField";
import React, {useEffect, useState} from "react";
import {useDropzone} from "react-dropzone";

const PairingPage = (props) => {
    const {title, text, image, radio, confirm} = props;
    const [pairingInstructionEditFlag, setPairingInstructionEdit] = useState(false);
    let [uploadedPairingImage, setUploadedPairingImage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    let [pTitle, setPTitle] = useState(title)
    let [pText, setPText] = useState(text)
    let [pRadio, setPRadio] = useState(radio)
    let [pConfirm, setPConfirm] = useState(confirm)

    let [oTitle, setOTitle] = useState(title)
    let [oText, setOText] = useState(text)
    let [oRadio, setORadio] = useState(radio)
    let [oConfirm, setOConfirm] = useState(confirm)



    function pairingInstructionEdit() {
        setPairingInstructionEdit(true)
        setOText(text);
        oText = text
        setOTitle(title);
        oTitle = title
        setORadio(radio);
        oRadio = radio
        setOConfirm(confirm)
        oConfirm = confirm
    }

    const onDrop = acceptedFiles => {
        //console.log("inisde file drop")
        if (acceptedFiles.length > 0) {
            const file = acceptedFiles[0];

            //console.log(file.type)

            // Check for valid image types (optional)
            const validImageTypes = ['image/jpeg', 'image/png'];
            if (!validImageTypes.includes(file.type)) {
                //console.error('Invalid image type. Please upload a JPEG or PNG file.');
                setErrorMessage('Invalid image type. Please upload a JPEG or PNG file.')
                return;
            }

            // Check for size limit (optional)
            if (file.size > 1048576) {  // 1 MB
                setErrorMessage('Image size exceeds 1 MB limit.')
                //console.error('Image size exceeds 1 MB limit.');
                return;
            }

            setErrorMessage("")
            setUploadedPairingImage(file);
            uploadedPairingImage = file
            sessionStorage.setItem("uploadedPairingImage", uploadedPairingImage)
        }
    };

    function handleCancelEdit() {
        setPairingInstructionEdit(false);
        setPText(oText);
        pText = oText
        setPTitle(oTitle);
        pTitle = oTitle
        setPRadio(oRadio);
        pRadio = oRadio
        setPConfirm(oConfirm)
        pConfirm = oConfirm
    }

    const handleTitleChange = (event) => {
        //console.log(event)
        setPTitle(event.target.textContent);
    };

    const handleTextChange = (event) => {
        //console.log(event)
        setPText(event.target.textContent);
    };

    const handleRadioChange = (event) => {
        //console.log(event)
        setPRadio(event.target.textContent);
    };

    const handleConfirmChange = (event) => {
        //console.log(event)
        setPConfirm(event.target.textContent);
    };

    const {getRootProps, getInputProps} = useDropzone({onDrop});

    /*useEffect(() => {
        setPText(text)
        setPTitle(title)
        console.log(title)
        console.log(text)
        console.log(pTitle)
        console.log(pText)
    }, []);*/

    pText = text
    pTitle = title
    /*console.log(title)
    console.log(text)*/
    /*console.log(title)
    console.log(text)
    console.log(pTitle)
    console.log(pText)*/

    return (
        <div
            className="flex h-full w-full flex-col rounded-[20px] px-[1px] pt-[3px] dark:bg-navy-900 sm:px-[150px] lg:px-[0px] xl:px-[35px]">
            <div className="flex w-full flex-row items-center justify-between">
                {/*<div className="flex items-center justify-between gap-2 rounded-[20px] md:!gap-[12px] md:px-2">
                    <h5 className="text-xl text-navy-700 dark:text-white">
                        <span className="text-gray-600 font-medium">Title: </span> {title === "" ?
                        <span className="gap-2 text-sm font-semibold text-navy-700 dark:text-white md:text-lg">Enter title</span> :
                        <span
                            className="gap-2 text-sm font-semibold text-navy-700 dark:text-white md:text-lg">{title}</span>}
                    </h5>
                </div>*/}
                <div className="flex items-center mt-2 justify-between gap-2 rounded-[20px] px-2 md:!gap-[12px]">
                    <div
                        className="flex h-11 w-11 items-center justify-center rounded-full bg-[#004c86] text-[40px] text-white md:h-[30px] md:w-[30px]">
                        <MdTitle/>
                    </div>
                    <div>
                        <p className="text-sm font-medium text-gray-600 md:text-base">
                            Title:
                        </p>
                        <div
                            className="flex items-center gap-1 text-sm font-semibold text-navy-700 dark:text-white md:gap-2 md:text-lg">
                            {pairingInstructionEditFlag === true ?
                                <p contentEditable="true" onInputCapture={handleTitleChange}> {" "}{pTitle === "" ? "Enter title" : pTitle} </p> :
                                <p contentEditable="false"> {" "}{title === "" ? "Enter title" : pTitle} </p>
                            }
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-between gap-2 rounded-[20px] md:!gap-[12px] md:px-2">
                    <div
                        className="flex h-11 w-11 items-center justify-center rounded-full bg-[#004c86] text-[40px] text-white md:h-[30px] md:w-[30px]">
                        <MdRadioButtonChecked/>
                    </div>
                    <div>
                        <p className="text-sm font-medium text-gray-600 md:text-base">
                            Radio Button Text:
                        </p>
                        <div
                            className="flex items-center gap-2 text-sm font-semibold text-navy-700 dark:text-white md:text-lg">
                            {pairingInstructionEditFlag === true ?
                                <p contentEditable="true" onInputCapture={handleRadioChange}>{" "}{pRadio === "" ? "Enter radio text" : pRadio}</p> :
                                <p contentEditable="false">{" "}{radio === "" ? "Enter radio text" : pRadio}</p>
                            }
                            {/*<p className="text-sm text-[#004c86] md:text-base">
                <MdRadioButtonChecked />
              </p>*/}
                        </div>
                    </div>
                </div>

                <div className="flex items-center justify-between gap-2 rounded-[20px] px-2 md:!gap-[12px]">
                    <div
                        className="flex h-11 w-11 items-center justify-center rounded-full bg-[#004c86] text-[40px] text-white md:h-[30px] md:w-[30px]">
                        <IoMdCheckmarkCircle/>
                    </div>
                    <div>
                        <p className="text-sm font-medium text-gray-600 md:text-base">
                            Confirm Button Text:
                        </p>
                        <div
                            className="flex items-center gap-1 text-sm font-semibold text-navy-700 dark:text-white md:gap-2 md:text-lg">
                            {pairingInstructionEditFlag === true ?
                                <p contentEditable="true" onInputCapture={handleConfirmChange}> {" "}{pConfirm === "" ? "Enter confirm text" : pConfirm} </p> :
                                <p contentEditable="false"> {" "}{confirm === "" ? "Enter confirm text" : pConfirm} </p>
                            }
                            {/*<p className="text-sm text-green-500 md:text-xl">
                <IoMdTrendingUp />
              </p>*/}
                        </div>
                    </div>
                </div>

                {pairingInstructionEditFlag === false ?
                    <div className="flex items-center justify-between gap-2 rounded-[20px] md:!gap-[12px] md:px-2"
                         onClick={pairingInstructionEdit}>
                        <p className="" style={{cursor: "pointer"}} onClick={pairingInstructionEdit}>
                            <MdEdit className="dark:text-gray-200"/>
                        </p>
                    </div> :
                    <button
                        className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600 grid grid-cols-2 gap-2 items-center"
                        id="editButton">
                        <MdOutlineSave className="text-green-800"/>
                        <MdOutlineCancel className="text-red-800" onClick={handleCancelEdit}/>
                    </button>
                }
            </div>

            {/* */}
            {/*<div className="mt-9 flex w-full flex-row items-center justify-between">
                <div className="flex items-center justify-between gap-2 rounded-[20px] md:!gap-[12px] md:px-2">
                    <div
                        className="flex h-11 w-11 items-center justify-center rounded-full bg-[#004c86] text-[40px] text-white md:h-[30px] md:w-[30px]">
                        <MdRadioButtonChecked/>
                    </div>
                    <div>
                        <p className="text-sm font-medium text-gray-600 md:text-base">
                            Radio Button Text:
                        </p>
                        <div
                            className="flex items-center gap-2 text-sm font-semibold text-navy-700 dark:text-white md:text-lg">
                            <p>{" "}{radio === "" ? "Enter radio text" : radio}</p>

                            <p className="text-sm text-[#004c86] md:text-base">
                <MdRadioButtonChecked />
              </p>
                        </div>
                    </div>
                </div>

                 monetization
                <div className="flex items-center justify-between gap-2 rounded-[20px] px-2 md:!gap-[12px]">
                    <div
                        className="flex h-11 w-11 items-center justify-center rounded-full bg-[#004c86] text-[40px] text-white md:h-[30px] md:w-[30px]">
                        <IoMdCheckmarkCircle/>
                    </div>
                    <div>
                        <p className="text-sm font-medium text-gray-600 md:text-base">
                            Confirm Button Text:
                        </p>
                        <div
                            className="flex items-center gap-1 text-sm font-semibold text-navy-700 dark:text-white md:gap-2 md:text-lg">
                            <p> {" "}{confirm === "" ? "Enter confirm text" : confirm} </p>

                            <p className="text-sm text-green-500 md:text-xl">
                <IoMdTrendingUp />
              </p>
                        </div>
                    </div>
                </div>
            </div>*/}

            {/* curret bide */}
            {/*<div className="flex h-full w-full flex-col xl:px-3">
                <div
                    className="mt-14 flex h-[450px] w-full flex-col items-center rounded-[20px] border border-gray-200 pt-10 shadow-xl shadow-gray-100 dark:!border-none dark:bg-navy-800 dark:shadow-none md:h-[515px]">
                    <h4 className="mt-4 text-[22px] font-medium text-navy-700 dark:text-white">
                        Current Bid
                    </h4>
                    <h1 className="mt-2 text-[45px] font-bold text-navy-700 dark:text-white md:text-[60px]">
                        {" "}
                        {text}{" "}
                    </h1>
                    <div className="mt-2 flex items-center gap-2">
                        <h3 className="text-2xl font-bold text-gray-600"> $10.927,84 </h3>
                        <p className="text-2xl text-green-500">
                            <IoMdTrendingUp/>
                        </p>
                    </div>
                    <h5 className="mt-[58px] text-xl font-medium text-navy-700 dark:text-white md:mt-[85px]">
                        Auction ends in
                    </h5>

                    <div className="mt-7 flex gap-14 md:mt-10">
                        <div className="flex flex-col items-center">
                            <h3 className="text-[35px] font-bold text-navy-700 dark:text-white md:text-[42px]">
                                20
                            </h3>
                            <p className="mt-1 text-2xl text-gray-600">Hrs</p>
                        </div>
                        <div className="flex flex-col items-center">
                            <h3 className="text-[35px] font-bold text-navy-700 dark:text-white md:text-[42px]">
                                37
                            </h3>
                            <p className="mt-1 text-2xl text-gray-600">Mins</p>
                        </div>
                        <div className="flex flex-col items-center">
                            <h3 className="text-[35px] font-bold text-navy-700 dark:text-white md:text-[42px]">
                                49
                            </h3>
                            <p className="mt-1 text-2xl text-gray-600">Secs</p>
                        </div>
                    </div>
                </div>

                <button
                    className="px-full linear mt-5 rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                    Place a bid
                </button>
            </div>*/}

            <br/>

            <span className="errorMessage">
                {errorMessage}
            </span>

            <div className="mt-3 grid h-full grid-cols-1 lg:grid-cols-3 mb-2 gap-5">
                <div className="col-span-1 h-fit w-full rounded-xl">
                    <div className="flex items-center justify-between gap-2 rounded-[20px] px-2 md:!gap-[12px]">
                        <div>
                            <p className="text-lg font-medium text-gray-600 md:text-base xl:text-lg">
                                Pairing Instruction Graphics:
                            </p>
                        </div>
                    </div>
                    <br/>
                    <div {...getRootProps()}
                         className="image-container relative">
                        <input {...getInputProps()} />
                        {uploadedPairingImage && (
                            <img src={URL.createObjectURL(uploadedPairingImage)}
                                 className="h-[182px] w-[284px] object-fit-cover rounded-xl"
                                 alt="Uploaded preview"/>
                        )}
                        {
                            !uploadedPairingImage &&
                            <img
                                className="h-fit w-fit rounded-xl"
                                src={image === "" || image === null ? "https://iot.crompton.co.in/CDN/img/provision/0bjf8pak2keloaa2/ic_pdt_enso2.0_1.png" : image}
                                alt=""
                            />
                        }

                        {pairingInstructionEditFlag === true &&
                            <div className="camera-icon-overlay absolute top-0 md:right-1/3 xl: right-1/3"><input
                                type="file"
                                accept="image/*" hidden/>
                                <input type="file" accept="image/*" hidden/>
                                <p
                                    className="text-xl h-full w-full rounded-full bg-[#004c86] p-2 cursor-pointer"
                                    /*onClick={() => document.querySelector('input[type="file"]').click()}*/
                                >
                                    <MdOutlineCameraAlt className="text-gray-300"/>
                                </p>
                            </div>
                        }
                    </div>

                    {pairingInstructionEditFlag === true &&
                        <p className="text-sm font-normal text-gray-600 p-2 dark:text-white xl:text-sm">
                            **Upload an image of 284*182. PNG, JPG and JPEG files are allowed.
                        </p>
                    }
                </div>

                <div className=" col-span-1 lg:col-span-2 h-full rounded-xl">
                    <p className="text-lg font-medium text-gray-600 dark:text-white xl:text-lg"
                       contentEditable="true">
                        {" "}
                        Pairing Instructions: {" "}
                    </p>
                    <div className="mt-2">
                        {pairingInstructionEditFlag === true ?
                            <p className="text-sm font-normal text-navy-700 dark:text-white xl:text-lg"
                               contentEditable="true" onInputCapture={handleTextChange}>
                                {" "}
                                {pText === "" ? "Enter steps to enable device in pairing mode" : pText}{" "}
                            </p> :

                            <p className="text-sm font-normal text-navy-700 dark:text-white xl:text-lg"
                               contentEditable="false">
                                {" "}
                                {text === "" ? "Enter steps to enable device in pairing mode" : pText}{" "}
                            </p>
                        }

                        {/*<TextField
                            label="Pairing Instructions:"
                            placeholder = {text}
                            id="textarea"
                            cols="30"
                            rows="8"
                        />*/}
                    </div>
                </div>
            </div>
            {/* <div className="mt-9 flex w-full flex-row items-center justify-between md:pl-4">
                <div className="flex items-center justify-between gap-2 rounded-[20px] md:!gap-[12px] md:px-2">
                    <img
                        className="h-full w-full rounded-xl"
                        src="https://images.pexels.com/photos/674010/pexels-photo-674010.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
                        alt=""
                    />
                </div>
                <div className="flex items-center justify-between gap-2 rounded-[20px] md:!gap-[12px] md:px-2">
                    <div className="mt-2">
                        <TextField
                            label="Bio"
                            placeholder="Enter a few words about you!"
                            id="textarea"
                            cols="30"
                            rows="8"
                        />
                    </div>
                </div>
            </div>*/}
        </div>
    );
};

export default PairingPage;
